/**
 * Loading screen management - shows on initial load, hides when map is ready.
 */

export function hideLoading() {
  const screen = document.getElementById('loading-screen');
  if (screen) {
    screen.classList.add('hidden');
    // Remove from DOM after transition
    setTimeout(() => screen.remove(), 700);
  }
}

/**
 * Show a dismissible error banner when map data fails to load.
 * Includes a Retry button that reloads the page.
 * Safe to call multiple times: only one banner is ever shown.
 */
export function showDataError(
  message = 'Could not load map data. Check your connection.'
): void {
  if (document.getElementById('data-error-banner')) return;

  const banner = document.createElement('div');
  banner.id = 'data-error-banner';
  banner.setAttribute('role', 'alert');
  banner.style.cssText = [
    'position:fixed',
    'top:0',
    'left:0',
    'right:0',
    'z-index:9999',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'gap:16px',
    'flex-wrap:wrap',
    'padding:12px 20px',
    'background:rgba(120,20,20,0.96)',
    'color:#fff',
    'font-family:var(--font-body, system-ui, sans-serif)',
    'font-size:14px',
    'font-weight:500',
    'box-shadow:0 2px 12px rgba(0,0,0,0.4)',
  ].join(';');

  banner.innerHTML = `
    <span class="data-error-message">${message}</span>
    <button
      type="button"
      class="data-error-retry"
      style="padding:6px 16px;font-size:13px;font-weight:600;font-family:inherit;color:#fff;background:rgba(255,255,255,0.18);border:1px solid rgba(255,255,255,0.5);border-radius:8px;cursor:pointer;"
    >Retry</button>
    <button
      type="button"
      class="data-error-dismiss"
      aria-label="Dismiss"
      style="padding:4px 8px;font-size:16px;line-height:1;color:#fff;background:none;border:none;cursor:pointer;"
    >&times;</button>
  `;

  document.body.appendChild(banner);

  banner.querySelector<HTMLButtonElement>('.data-error-retry')
    ?.addEventListener('click', () => window.location.reload());
  banner.querySelector<HTMLButtonElement>('.data-error-dismiss')
    ?.addEventListener('click', () => banner.remove());
}
